import * as React from 'react';
import { useTranslation } from 'react-i18next';
import slugify from 'slugify';
import { Accordion, StatusMessage } from '@hvcgroep/design-system';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { useGetFaqsByCategoryQuery } from '../../store/api-generated';
import SkeletonLoader from '../../components/SkeletonLoader';

type Props = {
  categoryId: string;
};

const Faqs = (props: Props) => {
  const { categoryId } = props;

  const { t } = useTranslation();

  const { isLoading, isError, data } = useGetFaqsByCategoryQuery({ categoryId });

  if (isLoading) {
    return <SkeletonLoader type="general" />;
  }

  if (isError) {
    return <StatusMessage type="error">{t('faq.error')}</StatusMessage>;
  }

  if (!data) {
    return <StatusMessage type="info">{t('faq.empty')}</StatusMessage>;
  }

  return (
    <>
      {data.map((faq) => (
        <Accordion
          key={`faq-${slugify(faq.question)}`}
          content={<WysiwygField html={faq.answer} />}
          title={faq.question}
          id={slugify(faq.question)}
        />
      ))}
    </>
  );
};

export default Faqs;
